import { postRequest } from '.';
import { GradeData, ReceiptGradeType } from '/types/index';
import { PRODUCT_CONDITION_TYPES, RECEIPT_GRADE_TYPES } from 'utils/constants';

interface RejectData {
  transaction_id: string | number;
  product_id: string;
  reject_note?: string;
  user_id: string;
  station_id: string;
}

const getReceiptGrade = (gradeData: GradeData): ReceiptGradeType | null => {
  if (
    gradeData.is_new === true &&
    gradeData.product_condition === PRODUCT_CONDITION_TYPES.HAS_PACKAGING
  )
    return RECEIPT_GRADE_TYPES.NIB;
  if (
    gradeData.is_new === true &&
    gradeData.product_condition === PRODUCT_CONDITION_TYPES.NO_PACKAGING
  )
    return RECEIPT_GRADE_TYPES.NOB;
  if (gradeData.is_new === false && gradeData.product_condition === PRODUCT_CONDITION_TYPES.USABLE)
    return RECEIPT_GRADE_TYPES.USABLE;
  if (
    gradeData.is_new === false &&
    gradeData.product_condition === PRODUCT_CONDITION_TYPES.UNUSABLE
  )
    return RECEIPT_GRADE_TYPES.SALVAGE;
  return null;
};

export const gradeItem = async (gradeData: GradeData) => {
  const receipt_grade = getReceiptGrade(gradeData);
  const payload = {
    receipt_line: {
      transaction_id: gradeData.transaction_id,
      receipt_line: gradeData.receipt_line,
      receipt_grade: receipt_grade,
      user_id: gradeData.user_id,
      station_id: gradeData.station_id,
    },
  };
  return postRequest('receipt-graded-line', payload); // TODO: it should be rpaas-receipt-graded-line-ui
};

export const startGrading = async (trackingId: string, userId: string, stationId: string) =>
  postRequest('receipt-graded-start', {
    // TODO: rpaas-receipt-graded-start-ui

    receipt: {
      tracking_id: trackingId,
      user_id: userId,
      station_id: stationId,
    },
    receipt_line: [],
  });

export const addProduct = async (gradeData: GradeData) => {
  const receipt_grade = getReceiptGrade(gradeData);
  const payload = {
    receipt_line: {
      transaction_id: gradeData.transaction_id,
      receipt_line: gradeData.receipt_line,
      receipt_grade: receipt_grade,
      user_id: gradeData.user_id,
      station_id: gradeData.station_id,
    },
  };
  return postRequest('rpass-receipt-graded-add-product-ui', payload);
};

export const rejectItem = async (rejectData: RejectData) => {
  const payload = {
    rpaasObject: {
      transaction_id: rejectData.transaction_id,
      reject_product_id: rejectData.product_id,
      reject_note: rejectData.reject_note || 'Item rejected',
      user_id: rejectData.user_id,
      station_id: rejectData.station_id,
      responseState: 'confirmed',
      responseMsg: '',
    },
  };
  return postRequest('receipt-graded-reject', payload);
};
